import { render, staticRenderFns } from "./HomeSplash.vue?vue&type=template&id=012a7df2"
import script from "./HomeSplash.vue?vue&type=script&lang=js"
export * from "./HomeSplash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports